import isEqual from 'lodash-es/isEqual'
import * as Yup from 'yup'

import { isDwellerRole } from '../../../utils/user'
import { toBuildingAddressSelectItem } from '../../Building'
import {
  EntityActionTypeSelectOptionValue,
  getEntityActionTypeSelectOptions,
} from '../../Entity'
import { toFlatSelectItem } from '../../Flat'
import { formValidationSchemaNoChanged } from '../../Form'
import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from '../../Formik'
import { toUserSelectItem } from '../../User'

import {
  REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_BUILDING,
  REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_FLAT,
  REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_OWNER,
} from './RequestEditApplicantAddressModal.constants'

function getRequestEditApplicantAddressModalComparableValues(values) {
  return {
    [REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_BUILDING]:
      values[REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_BUILDING]?.value ??
      null,
    [REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_FLAT]:
      values[REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_FLAT]?.value ??
      null,
    [REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_OWNER]:
      values[REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_OWNER]?.value ??
      null,
  }
}

function isRequestEditApplicantAddressModalFormFieldsEqual({
  initialValues,
  values,
}) {
  return isEqual(
    getRequestEditApplicantAddressModalComparableValues(initialValues),
    getRequestEditApplicantAddressModalComparableValues(values)
  )
}

export function getRequestEditApplicantAddressModalInitialValues({
  building,
  flat,
  owner,
}) {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return {
    [FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]:
      actionTypeOptions[EntityActionTypeSelectOptionValue.Edit],
    [REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_BUILDING]:
      building?.id && building?.address?.value
        ? toBuildingAddressSelectItem({
            address: building.address.value,
            id: building.id,
          })
        : null,
    [REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_FLAT]: flat?.id
      ? toFlatSelectItem(flat)
      : null,
    [REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_OWNER]: owner
      ? toUserSelectItem(owner)
      : null,
  }
}

export function getRequestEditApplicantAddressModalPayload(values) {
  return getRequestEditApplicantAddressModalComparableValues(values)
}

export function isRequestEditApplicantAddressModalAddressRequired(owner) {
  return Number.isFinite(owner?.value) && isDwellerRole(owner)
}

export function getRequestEditApplicantAddressModalValidationSchema({
  initialValues,
}) {
  return Yup.object({
    [REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_BUILDING]: Yup.object()
      .nullable()
      .when(REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_OWNER, {
        is: isRequestEditApplicantAddressModalAddressRequired,
        then: schema => schema.required(true),
      }),
    [REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_FLAT]: Yup.object()
      .nullable()
      .when(REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_OWNER, {
        is: isRequestEditApplicantAddressModalAddressRequired,
        then: schema => schema.required(true),
      }),
    [REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_OWNER]:
      Yup.object().required(true),
  }).concat(
    formValidationSchemaNoChanged({
      initialValues,
      isEqual: isRequestEditApplicantAddressModalFormFieldsEqual,
    })
  )
}
